// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-n_fJ","advertDetailService__price":"c-n_fK"};